__turbopack_context__.v({
  "heading": "SocialLinkSection-module__2Iyuva__heading",
  "iconRow": "SocialLinkSection-module__2Iyuva__iconRow",
  "socialLinkSection": "SocialLinkSection-module__2Iyuva__socialLinkSection",
});
